import { render, staticRenderFns } from "./faqContent.vue?vue&type=template&id=490bb51a&"
import script from "./faqContent.vue?vue&type=script&lang=js&"
export * from "./faqContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports